import { create } from 'zustand';

export interface ErisUser {
  id: string;
  name: string;
}

export interface ErisUserState {
  user: ErisUser | null;
  setUser: (user: ErisUser | null) => void;
}

export const useErisUserStore = create<ErisUserState>()((set) => ({
  user: null,
  setUser: (user) => {
    set({ user });
  },
}));
